import { render, staticRenderFns } from "./MfTagList.vue?vue&type=template&id=157f23e8&scoped=true&"
import script from "./MfTagList.vue?vue&type=script&lang=js&"
export * from "./MfTagList.vue?vue&type=script&lang=js&"
import style0 from "./MfTagList.vue?vue&type=style&index=0&id=157f23e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f23e8",
  null
  
)

export default component.exports